import React, { useMemo } from 'react'
import { text } from '@groovehq/internal-design-system/lib/styles/elements'
import { styles } from './styles'
import MenuItem from './MenuItem'

const Menu = ({ className, children, footer }) => {
  // toArray will filter out null children
  const childrenCount = useMemo(() => React.Children.toArray(children).length, [
    children,
  ])
  return (
    <div
      css={[
        styles.menuContainer,
        childrenCount >= 4 && styles.multipleColsMenuContainer,
      ]}
      className={className}
    >
      <div css={styles.menu} role="menu">
        {children}
      </div>
      {footer && (
        <div
          css={[text.styles.textSm, styles.footer]}
          className="grui p-7 text-center"
        >
          {footer}
        </div>
      )}
    </div>
  )
}

Menu.Item = MenuItem

export default Menu
